import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { AttainmentBar } from 'ui-deal-management-components-lib/components/attainmentBar/AttainmentBar';
import { jsx as _jsx } from "react/jsx-runtime";
export const DealSidebarAttainmentBar = ({
  goal,
  value
}) => /*#__PURE__*/_jsx(AttainmentBar, {
  currencyCode: goal.currencyCode,
  goal: goal.value,
  value: value.value,
  renderGoal: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "repOverviewTable.cells.goal",
    options: {
      value: I18n.formatIntlCurrency(goal.value, {
        currencyCode: goal.currencyCode
      })
    }
  }),
  renderValue: () => /*#__PURE__*/_jsx(FormattedIntlCurrency, {
    value: value.value,
    currencyCode: value.currencyCode
  }),
  showSubtext: false
});